import React from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { RefreshCw, X, CheckCircle2 } from 'lucide-react';

const PwaUpdateToast = () => {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log('PWA Service Worker registered:', r);
    },
    onRegisterError(error) {
      console.error('PWA Service Worker registration error:', error);
    },
  });

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  if (!offlineReady && !needRefresh) return null;

  return (
    <div className="fixed bottom-5 right-5 z-[9999] flex max-w-md items-center justify-between gap-4 rounded-xl bg-gray-900/95 p-4 text-white shadow-2xl backdrop-blur-md border border-gray-800 transition-all duration-300">
      <div className="flex items-center gap-3">
        {needRefresh ? (
          <RefreshCw className="h-5 w-5 text-blue-400 shrink-0 animate-spin" />
        ) : (
          <CheckCircle2 className="h-5 w-5 text-green-400 shrink-0" />
        )}
        <div className="text-sm font-medium">
          {needRefresh ? (
            <span>New version of SmartPro is available!</span>
          ) : (
            <span>SmartPro is ready to work offline.</span>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2 shrink-0">
        {needRefresh && (
          <button
            type="button"
            onClick={() => updateServiceWorker(true)}
            className="rounded-lg bg-blue-600 px-3.5 py-1.5 text-xs font-semibold text-white shadow hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors"
          >
            Update
          </button>
        )}
        <button
          type="button"
          onClick={close}
          className="rounded-lg p-1.5 text-gray-400 hover:bg-gray-800 hover:text-white transition-colors"
          aria-label="Close"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default PwaUpdateToast;
